import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';
import { useAppRouter } from '../../hooks/useAppRouter';
import { useCallState, getIsPhoneCall } from '../useCallState';

export const useIsPhoneCall = (): boolean => {
  const { pathname } = useAppRouter();
  const { paths } = getPublicRuntimeConfig();
  const { callState } = useCallState();

  const isInCall = pathname === paths.call;

  return isInCall && getIsPhoneCall(callState);
};
